/**
 * The stretches where the curve is at or above `level`, with the crossings interpolated
 * between grid points: when there is enough water over a shallow to cross it.
 */
export function above(points, level) {
    const windows = [];
    let start = null;
    let openStart = false;
    for (let i = 0; i < points.length; i++) {
        const p = points[i];
        const inside = p.level >= level;
        if (inside && start === null) {
            const prev = points[i - 1];
            if (!prev) {
                start = p.time;
                openStart = true;
            }
            else {
                const f = (level - prev.level) / (p.level - prev.level);
                start = prev.time + f * (p.time - prev.time);
                openStart = false;
            }
        }
        else if (!inside && start !== null) {
            const prev = points[i - 1];
            const f = (level - prev.level) / (p.level - prev.level);
            windows.push({ from: start, to: prev.time + f * (p.time - prev.time), openEnded: false, openStart });
            start = null;
        }
    }
    if (start !== null)
        windows.push({ from: start, to: points[points.length - 1].time, openEnded: true, openStart });
    return windows;
}
/**
 * The stretches where the curve is at or below `level`: when a boat fits under a bridge.
 * The mirror of `above`, and the crossings are interpolated the same way.
 */
export function below(points, level) {
    return above(points.map(p => ({ time: p.time, level: -p.level })), -level);
}
// ---- under a bridge: the same arithmetic upside down (obj_BridgePassing.pas:69) ----
/** What is left between the masthead and the bridge at a given tide level; negative does not fit */
export function mastClearance(levelCm, bridgeHeightCm, mastHeightCm) {
    return bridgeHeightCm - levelCm - mastHeightCm;
}
/** The tide level below which the bridge can be passed with the wanted clearance to spare */
export function passableBridgeLevel(bridgeHeightCm, mastHeightCm, clearanceCm) {
    return bridgeHeightCm - mastHeightCm - clearanceCm;
}
/** The seabed over a shallow, in cm NAP */
export function seabedLevel(depthCm) {
    return -depthCm;
}
/** Water over the shallow at a given tide level */
export function waterDepth(levelCm, depthCm) {
    return levelCm + depthCm;
}
/** What is left under the keel at a given tide level; negative means the boat does not fit */
export function keelClearance(levelCm, depthCm, draughtCm) {
    return levelCm + depthCm - draughtCm;
}
/** The tide level from which the shallow is passable with the wanted clearance to spare */
export function passableLevel(depthCm, draughtCm, clearanceCm) {
    return -depthCm + draughtCm + clearanceCm;
}
/**
 * The shift applied to the whole curve: the mean of the high- and low-water shifts, as
 * obj_LocatieInfo.pas computes `fTijLater`. Rounded down to whole minutes like the Delphi
 * integer division.
 */
export function curveOffsetMinutes(shallow) {
    return Math.floor((shallow.hwOffsetMinutes + shallow.lwOffsetMinutes) / 2);
}
/** The shift applied to one extremum: high and low water each move by their own */
export function extremumOffsetMinutes(shallow, type) {
    return type === 'HW' ? shallow.hwOffsetMinutes : shallow.lwOffsetMinutes;
}
/**
 * The reference station's time that produces the level over the shallow at `time`. The tide
 * runs `offsetMinutes` later here, so it is the station's level that much earlier.
 */
export function stationTime(time, offsetMinutes) {
    return time - offsetMinutes * 60_000;
}
/** The inverse: when a moment in the station's series happens over the shallow */
export function shallowTime(time, offsetMinutes) {
    return time + offsetMinutes * 60_000;
}
//# sourceMappingURL=depth.js.map